import { render, staticRenderFns } from "./PostFormDetail.vue?vue&type=template&id=a48b75a2&scoped=true&"
import script from "./PostFormDetail.vue?vue&type=script&lang=js&"
export * from "./PostFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostFormDetail.vue?vue&type=style&index=0&id=a48b75a2&scoped=true&lang=css&"
import style1 from "./PostFormDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48b75a2",
  null
  
)

export default component.exports